import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    email: "",
    id: "",
    name: "",
    role: "",
    app_user_uuid: "",
    app_user_auth_detail: "",
    zendesk_subdomain: "",
    time_zone: "",
  },

  reducers: {
    setUser: (state, action) => {
      state.email = action.payload.email;
      state.id = action.payload.id;
      state.name = action.payload.name;
      state.role = action.payload.role;
      state.app_user_uuid = action.payload.app_user_uuid;
      state.app_user_auth_detail = action.payload.app_user_auth_detail;
      state.zendesk_subdomain = action.payload.zendesk_subdomain;
      state.time_zone = action.payload.time_zone;
    },
    clearUser: (state) => {
      state.email = "";
      state.id = "";
      state.name = "";
      state.role = "";
      state.app_user_uuid = "";
      state.app_user_auth_detail = "";
      state.zendesk_subdomain = "";
      state.time_zone = "";
    },
  },
});

// Action creators are generated for each case reducer function
export const { clearUser, setUser } = userSlice.actions;

export default userSlice.reducer;
